var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("הוספת קובץ")]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogReportPaid__Component__Loading" },
          [
            _c(
              "div",
              [
                _c(
                  "b-field",
                  { attrs: { label: "בחירת קובץ" } },
                  [
                    _c(
                      "b-upload",
                      {
                        staticClass: "file-label",
                        attrs: { accept: ".png,.jpg,.pdf,.jpeg,.mp3" },
                        model: {
                          value: _vm.file,
                          callback: function ($$v) {
                            _vm.file = $$v
                          },
                          expression: "file",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "file-cta" },
                          [
                            _c("b-icon", {
                              staticClass: "file-icon",
                              attrs: { icon: "upload" },
                            }),
                            _c("span", { staticClass: "file-label" }, [
                              _vm._v("בחירת קובץ"),
                            ]),
                          ],
                          1
                        ),
                        _vm.file
                          ? _c("span", { staticClass: "file-name" }, [
                              _vm._v(" " + _vm._s(_vm.file.name) + " "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { label: "לאן להעלות" },
              },
              [
                _c("FieldInlineSelect", {
                  staticStyle: { width: "50%" },
                  attrs: {
                    label: "",
                    filterable: false,
                    clearable: false,
                    options: [
                      { Value: 1, Text: "כללי" },
                      { Value: 2, Text: "ספרים" },
                      { Value: 3, Text: "הודעות" },
                      { Value: 5, Text: "הרצאות" },
                      { Value: 6, Text: "דואר אלקטרוני" },
                      { Value: 7, Text: "דף הבית" },
                      { Value: 8, Text: "חקיקה" },
                      { Value: 9, Text: "כרטיסיות" },
                    ],
                    required: "true",
                  },
                  model: {
                    value: _vm.folderType,
                    callback: function ($$v) {
                      _vm.folderType = $$v
                    },
                    expression: "folderType",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }